import React, { useEffect, useState } from 'react';
import HeaderContainer from '../HeaderContainer';
import FooterContainer from '../FooterContainer';
import MyEirPhoneNumber from './MyEirPhoneNumber';
import { useHistory } from 'react-router-dom';
import MyEirVerificationCode from './MyEirVerificationCode';
import MyEirEnterAccountNumber from './MyEirEnterAccountNumber';
import MyEirRegisterEmail from './MyEirRegisterEmail';
import MyEirCreatePasswordFormPage from '../my-eir-createPassword/MyEirCreatePasswordFormPage';
import MyEirForgotPasswordForm from '../my-eir-forgotPassword/MyEirForgotPasswordForm';
import MFAOtpScreen from '../../mobilecomponents/my-login/MFAOtpScreen';
import { sendMfaOtp } from '../../mobilecomponents/my-login/loginOperation.api';

function PasswordContainer(props) {
    const [step, setStep] = useState(props.mfa ? 0 : 1);
    const [resetScreen, setResetScreen] = useState(false);

    const history = useHistory();
    const handleBackButton = () => {
        if (step == 0) {
            // console.log('back from step1');
        } else {
            setStep(step - 1);
        }
    };

    const handleNextFlow1 = () => {
        if (step == 5) {
            // console.log('Last Step');
        } else {
            setStep(step + 1);
        }
    };

    const closeBtn = () => {
        setResetScreen(true);
    };

    useEffect(() => {
        if (props.mfa) setStep(0);
    }, [props.mfa]);

    return (
        <div className='my-eir-reset-page'>
            {
                {
                    0: (
                        <MFAOtpScreen
                            handleBackButton={handleBackButton}
                            handleNextFlow1={handleNextFlow1}
                            username={props.username}
                            otpUuid={props.otpUuid}
                            delivery={props.delivery}
                            flag='reset'
                        />
                    ),
                    1: (
                        <MyEirCreatePasswordFormPage
                            handleBackButton={handleBackButton}
                            handleNextFlow1={handleNextFlow1}
                        />
                    ),
                }[step]
            }
        </div>
    );
}
export default PasswordContainer;
